import EPG from './EPG';
import {
    EPGAlignment,
    EPGChannel,
    EPGChannels,
    EPGConfig,
    EPGProgram,
    EPGPrograms,
    EPGProps,
    EPGRequestPriority,
    IEPG,
} from './types';

export { EPG, EPGAlignment, EPGRequestPriority };

export type {
    EPGConfig,
    EPGChannel,
    EPGChannels,
    EPGProgram,
    EPGPrograms,
    EPGProps,
    IEPG,
};
